import { render, staticRenderFns } from "./ServicoOrcamentoCadastroModal.vue?vue&type=template&id=a05fdbe4&scoped=true"
import script from "./ServicoOrcamentoCadastroModal.vue?vue&type=script&lang=js"
export * from "./ServicoOrcamentoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./ServicoOrcamentoCadastroModal.vue?vue&type=style&index=0&id=a05fdbe4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a05fdbe4",
  null
  
)

export default component.exports